(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityTemplatePreview', drvEntityTemplatePreview);

    /**
     * @ngdoc directive
     * @name drvEntityTemplatePreview
     * 
     * @param {object} entityTemplate - Entity template for which the preview will be shown.
     *
     * @description
     * Formats preview of an entity template for display.
     */
    function drvEntityTemplatePreview() {
        return {
            templateUrl: 'app/entitytemplate/entity-template-preview.tmpl.html',
            scope: {
            },
            controller: drvEntityTemplatePreviewCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                entityTemplate: '='
            }
        };
    }

    drvEntityTemplatePreviewCtrl.$inject = [];

    function drvEntityTemplatePreviewCtrl() {
        /* jshint validthis:true */
        var drvCtrl = this;
    }
})();
